<template>
    <section class="character-wrap" :class="{ 'mask': !showRole }">
        <audio ref="say" @canplay="canplay=true" @pause="pause" @ended="playing=false" @playing="playing=true" v-if="seledRole" :src="seledRole.cvFile"></audio>

        <div class="camp-wrap">
            <!-- 阵营选择 -->
            <ul class="camp-container">
                <template v-for="(item, index) in camplist">
                    <transition :name="slideType(index)" :key="`camp-${index}`">
                        <li
                            class="camp-box"
                            v-show="showCamp"
                            @click="showCampRole(item)"
                        >
                            <img class="camp-bg" :src="item.offImg" alt />
                        </li>
                    </transition>
                </template>
            </ul>
        </div>
        <!-- 阵营logo -->
        <transition name="camplogo">
            <div v-show="seledCampData" class="camp-logo" @click="returnCamplist">
                <a href="javascript:void(0)" title="back">
                    <div class="current-camp-logo" :style="{ 'background-image': `url(${currentCampLogo})` }"></div>
                    <div class="other-camp-logo-wrap">
                        <div class="other-camp-logo" 
                        v-for="(item, index) in logoList" 
                        v-show="item.logo !== currentCampLogo"
                        :key="`camp-logo-${index}`"
                        :style="{ 'background-image': `url(${item.logo})` }"
                        ></div>
                    </div>
                </a>
            </div>
        </transition>
        <!-- 角色选择 -->
        <div class="role-wrap" v-show="showRole">
            <!-- 真实角色列表 -->
            <ul class="role-container">
                <li
                    class="role-box"
                    v-for="(item, index) in seledCampData.rolelist"
                    :key="`role-${index}`"
                >
                    <div
                        class="role-content"
                        :class="[hoverClass(index),  seledClass(index)]"
                        :style="[posLeft(index, seledCampData.rolelist.length), item.roleStyle]"
                    >
                        <img class="role" :style="item.imgStyle" :src="item.roleImg" alt />

                        <transition name="roleDetail">
                            <div class="role-detail" v-show="seledRoleIndex == index" :style="item.detailStyle">
                                <transition name="roleClass">
                                    <div class="role-class" v-show="seledRoleIndex == index">
                                        <img :src="item.roleType" alt />
                                    </div>
                                </transition>
                                <i class="iconfont iconguanbi1 role-close" @click="closeRole"></i>
                                <transition name="clip">
                                    <p class="role-name--jp" v-show="seledRoleIndex == index">{{ item.roleName_jp }}</p>
                                </transition>
                                <transition name="clip">
                                    <div class="cv-name-box" v-show="seledRoleIndex == index">
                                        <p class="cv-box">
                                            <a class="cv-button" href="javascript:void(0);" @click="playAudio" :class="{ 'play': playing }">
                                                <img src="../../assets/images/character/role_cv_close.png" class="cv-btn"  alt="">
                                            </a>
                                            <span class="cv-name">{{ item.cvName }}</span>
                                        </p>
                                        <p class="role-name--en">{{ item.roleName_en }}</p>
                                    </div>
                                </transition>
                                <transition name="clip">
                                    <p class="role-detail-text" v-show="seledRoleIndex == index">{{ item.detailText }}</p> 
                                </transition>
                            </div>
                        </transition>
                    </div>
                </li>
            </ul>
            <!-- 触发mouseover,click事件列表 -->
            <ul class="mover-container">
                <li
                    class="mover-box"
                    v-for="(item, index) in seledCampData.rolelist"
                    :style="posLeft(index, seledCampData.rolelist.length)"
                    :key="`mover-${index}`"
                    @mouseover="moverRole(index)"
                    @mouseleave="mouseleaveRole"
                    @click="selRole(index, seledRoleIndex != -1)"
                ></li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: "character",

    components: {

    },
    data: () => ({
        logoList: [
            {
                name: 'camp01',
                logo: require("../../assets/images/character/camp01/logo.png"),
            },
            {
                name: 'camp02',
                logo: require("../../assets/images/character/camp02/logo.png"),
            },
            {
                name: 'camp03',
                logo: require("../../assets/images/character/camp03/logo.png"),
            },
            {
                name: 'camp04',
                logo: require("../../assets/images/character/camp04/logo.png"),
            },
            {
                name: 'camp05',
                logo: require("../../assets/images/character/camp05/logo.png"),
            }
        ],
        camplist: [
            {
                name: 'camp01',
                onImg: require("../../assets/images/character/camp01/1-on.png"),
                offImg: require("../../assets/images/character/camp01/1-off.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/character/camp01/role01.png"),
                        roleType: require("../../assets/images/character/tezhong.png"),
                        roleName_jp: "",
                        roleName_en: "PROJEKT RED",
                        detailText: 'Projekt Red, an abandoned child, was raised by a woman she calls "grandma", and has been feared by her fellow Lupo ever since.',
                        cvName: "Ami Koshimizu",
                        cvFile: require("../../assets/audio/character/camp01/CN_001.mp3")
                    },
                    {
                        roleImg: require("../../assets/images/character/camp01/role02.png"),
                        roleType: require("../../assets/images/character/yiliao.png"),
                        roleName_jp: "",
                        roleName_en: "KAL'TSIT",
                        detailText: "Kal'tsit is the director of medical projects at Rhodes Island. An expert in many fields, she serves as a medic operator in some of Rhodes Island’s operations, offering medical advice and operating medical devices.",
                        cvName: "Yoko Hikasa",
                        cvFile: require("../../assets/audio/character/camp01/CN_002.mp3")
                    },
                    {
                        roleImg: require("../../assets/images/character/camp01/role03.png"),
                        roleType: require("../../assets/images/character/sushi.png"),
                        roleName_jp: "",
                        roleName_en: "AMIYA",
                        detailText: "Amiya is the official leader of Rhodes Island.",
                        cvName: "Tomoyo Kurosawa",
                        cvFile: require("../../assets/audio/character/camp01/CN_003.mp3")
                    },
                    {
                        roleImg: require("../../assets/images/character/camp01/role04.png"),
                        roleType: require("../../assets/images/character/jinwei.png"),
                        roleName_jp: "",
                        roleName_en: "DOBERMANN",
                        detailText: "Dobermann is in charge of tactical training at Rhodes Island. Meticulous and strict, she carefully oversees the company's training regimens, aiming to reduce battlefield casualties to zero.",
                        cvName: "Atsumi Tanezaki",
                        cvFile: require("../../assets/audio/character/camp01/CN_004.mp3")
                    },
                    {
                        roleImg: require("../../assets/images/character/camp01/role05.png"),
                        roleType: require("../../assets/images/character/zhongzhuang.png"),
                        roleName_jp: "",
                        roleName_en: "NEARL",
                        detailText: "Nearl is a Rhodes Island Defender Operator. Her strong sense of determination and commitment to the cause has made her the Shield of Rhodes Island.",
                        cvName: "Ayane Sakura",
                        cvFile: require("../../assets/audio/character/camp01/CN_005.mp3"),
                        detailStyle: {
                            'width': '300%',
                            'padding-left': '120%',
                        }
                    }
                ]
            },
            {
                name: 'camp02',
                onImg: require("../../assets/images/character/camp02/2-on.png"),
                offImg: require("../../assets/images/character/camp02/2-off.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/character/camp02/role01.png"),
                        roleType: require("../../assets/images/character/zhongzhuang.png"),
                        roleName_jp: "",
                        roleName_en: "HOSHIGUMA",
                        detailText: "Hoshiguma is an elite agent from the Special Inspection Unit of the Lungmen Guard Department. In spite of her criminal record, she was handpicked for the S.I.U. by Governor Wei Yenwu himself. Currently on loan to Rhodes Island as a defender, she provides tactical and command support.",
                        cvName: "Kiyono Yasuno",
                        cvFile: require("../../assets/audio/character/camp02/CN_001.mp3"),
                        detailStyle: {
                            'width': '290%',
                            'padding-left': '100%',
                        }
                    },
                    {
                        roleImg: require("../../assets/images/character/camp02/role02.png"),
                        roleType: require("../../assets/images/character/jinwei.png"),
                        roleName_jp: "",
                        roleName_en: "CH'EN",
                        detailText: "Ch'en is the chief of the Special Inspection Unit of the Lungmen Guard Department. During her time with the unit, she was recognized for her efforts to combat criminal activity and organized crime in particular. Now on loan to Rhodes Island as part of a special cooperation agreement, she provides tactical and command support.",
                        cvName: "Shizuka Ishigami",
                        cvFile: require("../../assets/audio/character/camp02/CN_002.mp3"),
                    }
                ]
            },
            {
                name: 'camp03',
                onImg: require("../../assets/images/character/camp03/3-on.png"),
                offImg: require("../../assets/images/character/camp03/3-off.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/character/camp03/role01.png"),
                        roleType: require("../../assets/images/character/zhongzhuang.png"),
                        roleName_jp: "",
                        roleName_en: "CROISSANT",
                        detailText: "Croissant is a cheerful and vivacious employee of Penguin Logistics with a love of shopping. Every day, she works hard towards building a better life for herself.",
                        cvName: "Yurika Kubo",
                        cvFile: require("../../assets/audio/character/camp03/CN_001.mp3"),
                    },
                    {
                        roleImg: require("../../assets/images/character/camp03/role02.png"),
                        roleType: require("../../assets/images/character/xianfeng.png"),
                        roleName_jp: "",
                        roleName_en: "TEXAS",
                        detailText: "Texas is an employee of Penguin Logistics. Her duties include covert communications and armored vehicle transport, leading to speculation that she is, in fact, a Messenger. Penguin Logistics has assigned her to Rhodes Island, where she assists with various operations.",
                        cvName: "Azusa Tadokoro",
                        cvFile: require("../../assets/audio/character/camp03/CN_002.mp3"),
                    },
                    {
                        roleImg: require("../../assets/images/character/camp03/role03.png"),
                        roleType: require("../../assets/images/character/juji.png"),
                        roleName_jp: "",
                        roleName_en: "EXUSIAI",
                        detailText: "Exusiai is a citizen of Laterano and an employee at Penguin Logistics. Her duties include covert communication and armored vehicle transport, leading to speculation that she is, in fact, a Messenger. Penguin Logistics has assigned her to Rhodes Island, where she assists with various operations.",
                        cvName: "Manaka Iwami",
                        cvFile: require("../../assets/audio/character/camp03/CN_003.mp3"),
                        detailStyle: {
                            'width': '280%',
                            'padding-left': '100%',
                        }
                    }
                ]
            },
            {
                name: 'camp04',
                onImg: require("../../assets/images/character/camp04/4-on.png"),
                offImg: require("../../assets/images/character/camp04/4-off.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/character/camp04/role01.png"),
                        roleType: require("../../assets/images/character/yiliao.png"),
                        roleName_jp: "",
                        roleName_en: "PTILOPSIS",
                        detailText: "A former data analyst with Rhine Lab, Ptilopsis is an expert in triage and data management. She is known for her mechanical execution of her duties, and her calm and composed demeanor.",
                        cvName: "Hisako Kanemoto",
                        cvFile: require("../../assets/audio/character/camp04/CN_001.mp3"),
                    },
                    {
                        roleImg: require("../../assets/images/character/camp04/role02.png"),
                        roleType: require("../../assets/images/character/sushi.png"),
                        roleName_jp: "",
                        roleName_en: "IFRIT",
                        detailText: "Ifrit was once a patient at Rhine Lab with severe Oripathy. She is highly attuned to Originium, causing her body to ignite at unpredictable intervals. We have no record of her life prior to her admission to Rhine Lab. She currently receives treatment at Rhodes Island, where Silence serves as her guardian and guarantor.",
                        cvName: "Yumiri Hanamori",
                        cvFile: require("../../assets/audio/character/camp04/CN_002.mp3"),
                        detailStyle: {
                            'width': '280%',
                            'padding-left': '100%',
                        }
                    },
                    {
                        roleImg: require("../../assets/images/character/camp04/role03.png"),
                        roleType: require("../../assets/images/character/yiliao.png"),
                        roleName_jp: "",
                        roleName_en: "SILENCE",
                        detailText: "Silence is an Originium researcher with Rhine Lab. She has headed up multiple research projects, the details of which remain unknown to us, as well as Originium clinical testing programs. She is currently assigned to Rhodes Island, where she works as a Medic Operator.",
                        cvName: "Akari Kito",
                        cvFile: require("../../assets/audio/character/camp04/CN_003.mp3"),
                    },
                ]
            },
            {
                name: 'camp05',
                onImg: require("../../assets/images/character/camp05/5-on.png"),
                offImg: require("../../assets/images/character/camp05/5-off.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/character/camp05/role01.png"),
                        roleType: require("../../assets/images/character/jinwei.png"),
                        roleName_jp: "",
                        roleName_en: "FRANKA",
                        detailText: "Franka is an employee of Blacksteel Worldwide and Liskarm’s partner. The reasons for her assignment at Rhodes Island are unique…",
                        cvName: "Ai Kakuma",
                        cvFile: require("../../assets/audio/character/camp05/CN_001.mp3"),
                    },
                    {
                        roleImg: require("../../assets/images/character/camp05/role02.png"),
                        roleType: require("../../assets/images/character/zhongzhuang.png"),
                        roleName_jp: "",
                        roleName_en: "LISKARM",
                        detailText: "Liskarm is an employee of Blacksteel Worldwide, where she accumulated a wealth of combat experience. She is on loan to Rhodes Island as a security consultant.",
                        cvName: "Yui Ishikawa",
                        cvFile: require("../../assets/audio/character/camp05/CN_002.mp3"),
                        detailStyle: {
                            'width': '260%',
                            'padding-left': '70%',
                        }
                    },
                ]
            },
        ],
        showCamp: false,
        showRole: false,    // 显示角色列表

        firstShow: true,    // 第一次进入该版块
        seledCampData: "",  // 选中的阵营数据
        hoverIndex: -1,     // 鼠标mouseover角色index,
        seledRole: "",      // 选中的角色数据
        seledRoleIndex: -1, // 选中角色index

        camplogoTemp: '',   // 阵营图标临时数据

        // audio
        playing: false,
        canplay: false,

        // cv btn
        cvHoverLeft: 0,
        cvHoverTop: 0,
        cvHoverWidth: 0,
        cvHoverHeight: 0,
    }),
    created() {

    },
    mounted() {
        
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val === 3 && this.firstShow) {
                this.firstShow = false;
                
                setTimeout(() => {
                    this.showCamp = true;
                }, 500);
            }
            if(this.seledRole) {
                this.clearAudioState();
            }
        }
    },
    computed: {
        currentCampLogo() {
            if(this.seledCampData) {
                for(let i = 0, len = this.logoList.length; i < len; i++) {
                    if(this.logoList[i].name == this.seledCampData.name) {
                        this.camplogoTemp = this.logoList[i].logo
                        return this.logoList[i].logo
                    }
                }
            } else {
                return this.camplogoTemp
            }
        },
        NAV_ACTIVE_INDEX() {
            return this.$store.getters.NAV_ACTIVE_INDEX
        }
    },
    methods: {
        playAudio() {
            if (this.playing) {
                this.$refs['say'].pause()
            } else {
                this.$refs['say'].play()
            }
        },
        pause() {
            this.playing = false
        },
        clearAudioState() {
            this.$refs['say'].currentTime = 0
            this.$refs['say'].pause()
            this.playing = false
        },
        campBg(item) {
            if (item.stage <= this.CAMP_STAGE) {
                return item.openImg;
            } else {
                return item.closeImg;
            }
        },
        slideType(index) {
            if (index % 2 == 0) {
                return "slideTop";
            } else {
                return "slideBottom";
            }
        },
        showCampRole(item) {
            // 隐藏阵营
            this.showCamp = false;
            this.showRole = true;
            this.seledCampData = item;
        },
        moverRole(index) {
            if (this.seledRoleIndex != -1) {
                // 选中角色后禁止mouse事件
                return;
            }
            this.hoverIndex = index;
        },
        mouseleaveRole() {
            if (this.seledRoleIndex != -1) {
                // 选中角色后禁止mouse事件
                return;
            }
            this.hoverIndex = -1;
        },
        hoverClass(index) {
            if (this.hoverIndex == -1) {
                return "";
            } else if (this.hoverIndex == index) {
                // hover角色
                return "hover-active";
            } else if (this.hoverIndex < index) {
                return "hover-right";
            } else if (this.hoverIndex > index) {
                return "hover-left";
            }
        },
        seledClass(index) {
            if (this.seledRoleIndex == -1) {
                return "";
            } else if (this.seledRoleIndex == index) {
                return "sel-active";
            } else {
                return "no-sel-active";
            }
        },
        posLeft(index, roleLength) {
            if (roleLength == 2) {
                let posleft = 30 + index * 20 + "%";
                return {
                    left: posleft
                };
            } else if(roleLength == 3) {
                let posleft = 20 + index * 20 + "%";
                return {
                    left: posleft
                };
            } else {
                let posleft = (index / roleLength) * 100 + "%";
                return {
                    left: posleft
                };
            }
        },
        selRole(index, locked) {
            if (locked) {
                return;
            }

            this.seledRole = this.seledCampData.rolelist[index];
            this.hoverIndex = -1;
            this.seledRoleIndex = index;
        },
        closeRole() {
            this.seledRole = "";
            this.seledRoleIndex = -1;
        },
        returnCamplist() {
            this.showCamp = true;
            this.showRole = false;
            this.seledCampData = "";

            setTimeout(() => {
                this.closeRole();
            }, 50)
        },
    },
};
</script>

<style lang="scss" scoped>
.character-wrap {
    background: #000 url("../../assets/images/character/bg.jpg") no-repeat;
    background-size: cover;
    background-position: center top;
    position: relative;
    overflow: hidden;

    &.mask {
        &::after {
            opacity: 1;
        }
    }

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #141516;
        z-index: 1;
        opacity: 0;
        transition: all 0.3s ease-in-out;
    }

    .camp-wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;

        .camp-container {
            display: flex;
            justify-content: center;
            
            .camp-box {
                flex-grow: 0;
                width: auto;
                height: pxTorem(862px);
                cursor: pointer;
                position: relative;
                background: #141516;

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: all 0.8s;
                }

                &:not(:first-child) {
                    margin-left: -2.5%;
                }

                &:nth-of-type(1) {
                    z-index: 10;
                    &::after {
                        background: url("../../assets/images/character/camp01/1-on.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(2) {
                    z-index: 9;
                    &::after {
                        background: url("../../assets/images/character/camp02/2-on.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(3) {
                    z-index: 8;
                    &::after {
                        background: url("../../assets/images/character/camp03/3-on.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(4) {
                    z-index: 7;
                    &::after {
                        background: url("../../assets/images/character/camp04/4-on.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(5) {
                    z-index: 6;
                    &::after {
                        background: url("../../assets/images/character/camp05/5-on.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }

                .camp-bg {
                    display: block;
                    height: 100%;
                }

                &:hover {
                    &::after {
                        opacity: 1;
                    }
                }
            }
        }
    }
    /* camp logo */
    .camp-logo {
        position: absolute;
        z-index: 10;
        width: pxTorem(320px);
        height: pxTorem(320px);
        top: pxTorem(50px);
        left: pxTorem(40px);
        cursor: pointer;
        overflow: hidden;

        .current-camp-logo {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-size: 100%;
            backface-visibility: hidden;
            transition: all .3s ease-in-out;
        }
        .other-camp-logo-wrap {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transition: all .3s ease-in-out;
            padding: 5%;
            backface-visibility: hidden;
            display: flex;
            flex-wrap: wrap;
            transform: rotateY(180deg);

            .other-camp-logo {
                background-size: 100%;
                background-repeat: no-repeat;
                width: 50%;
                height: 50%;
            }
        }

        &:hover {
            .current-camp-logo {
                transform: rotateY(-180deg);
            }
            .other-camp-logo-wrap {
                transform: rotateY(0);
            }
        }
    }
     /* 角色 */
    .role-wrap {
        position: absolute;
        top: 55%;
        left: 55%;
        transform: translate(-50%, -50%);
        z-index: 2;
        width: 70%;
        height: 80%;
        box-sizing: border-box;

        .role-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            position: relative;

            .role-box {
                width: pxTorem(270px);
                height: 100%;
                box-sizing: border-box;

                .role-content {
                    width: pxTorem(270px);
                    height: 100%;
                    position: absolute;
                    top: 0;
                    transition: transform 0.2s ease-in-out, all 0.3s ease-in-out;

                    /* detail */
                    .role-detail {
                        width: pxTorem(650px);
                        position: absolute;
                        top: 53%;
                        left: 40%;
                        z-index: -1;
                        box-sizing: border-box;
                        padding: pxTorem(25px) pxTorem(20px) pxTorem(25px)
                            pxTorem(220px);
                        background: rgba(20, 21, 22, 0.9);
                        transform: translateY(-50%) scaleX(1);
                        transition: all 0.3s ease-in-out;

                        .role-class {
                            height: pxTorem(110px);
                            position: absolute;
                            left: 0;
                            right: 45%;
                            top: pxTorem(-55px);
                            box-sizing: border-box;
                            background: #fff;
                            text-align: right;
                            font-size: 0;
                            
                                img {
                                    height: 100%;
                                }
                            }
                            /* .role-name-cv-box {
                                width: 100%;
                                height: pxTorem(80px);
                                display: flex;
                                justify-content: space-between;

                                .role-name {
                                    flex-grow: 0;
                                    height: 80%;
                                    img {
                                        height: 100%;
                                    }
                                }
                                .role-cv {
                                    width: pxTorem(116px);
                                    height: auto;
                                    align-self: flex-end;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;

                                    .role-cv-box {
                                        position: relative;
                                        .cv-btn {
                                            height: 120%;
                                        }
                                        &::after {
                                            content: "";
                                            display: block;
                                            position: absolute;
                                            width: 100%;
                                            height: 100%;
                                            top: 0;
                                            left: 0;
                                            background: url("../../assets/images/home/character/role_cv.png") no-repeat;
                                            background-size: 100% 100%;
                                            opacity: 0;
                                        }
                                        &::before {
                                            content: "";
                                            display: block;
                                            width: 40%;
                                            height: 40%;
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            transform: translate(-50%, -50%);
                                            z-index: -1;
                                            box-shadow: 0 0 20px 1px #007eff;
                                            border-radius: 50%;
                                            animation: lightScale 1s ease-in-out alternate infinite;
                                            opacity: 0;

                                            @keyframes lightScale {
                                                from {
                                                    box-shadow: 0 0 20px 1px #007eff;
                                                }
                                                to {
                                                    box-shadow: 0 0 20px 10px #007eff;
                                                }
                                            }
                                        }
                                        &.play {
                                            &::after {
                                                opacity: 1;
                                            }
                                            &::before {
                                                opacity: 1;
                                            }
                                        }
                                    }
                                    
                                    .cv {
                                        font-size: pxTorem(16px);
                                        color: #fff;
                                        white-space: nowrap;
                                        font-family: 'Noto Sans KR', sans-serif;
                                        font-weight: 700;
                                    }
                                }
                            } */
                        }
                        .role-close {
                            color: #fff;
                            font-size: pxTorem(35px);
                            position: absolute;
                            left: 100%;
                            top: 0;
                            transform: translateY(-100%);
                            cursor: pointer;
                        }
                        .role-name--jp {
                            width: 100%;
                            color: #fff;
                            font-size: pxTorem(38px);
                            text-align: right;
                            line-height: 1;
                            margin-bottom: pxTorem(5px);
                        }
                        .cv-name-box {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            font-size: 0;
                            line-height: 1;
                            margin-top: pxTorem(40px);
                            margin-bottom: pxTorem(20px);

                            .cv-box {
                                display: flex;
                                font-size: 0;
                                align-self: flex-end;
                                align-items: center;
                                
                                .cv-button {
                                    display: block;
                                    width: pxTorem(30px);
                                    margin-bottom: pxTorem(-5px);
                                    position: relative;
                                    
                                    .cv-btn {
                                        width: 100%;
                                    }

                                    &::after {
                                        content: "";
                                        display: block;
                                        position: absolute;
                                        width: 100%;
                                        height: 100%;
                                        top: 0;
                                        left: 0;
                                        background: url("../../assets/images/character/role_cv.png") no-repeat;
                                        background-size: 100% 100%;
                                        opacity: 0;
                                    }
                                    &::before {
                                        content: "";
                                        display: block;
                                        width: 40%;
                                        height: 40%;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        z-index: -1;
                                        box-shadow: 0 0 20px 1px #007eff;
                                        border-radius: 50%;
                                        animation: lightScale 1s ease-in-out alternate infinite;
                                        opacity: 0;

                                        @keyframes lightScale {
                                            from {
                                                box-shadow: 0 0 20px 1px #007eff;
                                            }
                                            to {
                                                box-shadow: 0 0 20px 10px #007eff;
                                            }
                                        }
                                    }
                                    &.play {
                                        &::after {
                                            opacity: 1;
                                        }
                                        &::before {
                                            opacity: 1;
                                        }
                                    }
                                }
                                .cv-name {
                                    font-family: 'SourceHanSansSubset', sans-serif;
                                    color: #fff;
                                    font-size: pxTorem(14px);
                                    line-height: 1;
                                    margin-left: pxTorem(5px);
                                }
                            }
                            .role-name--en {
                                font-family: "SourceHanSansSubset";
                                color: #fff;
                                font-weight: 700;
                                font-size: pxTorem(38px);
                                line-height: 1;
                            }
                        }
                        .role-detail-text {
                            color: #999;
                            font-family: 'SourceHanSansSubset', sans-serif;
                            font-size: pxTorem(14px);
                            width: 100%;
                            box-sizing: border-box;
                            padding-left: pxTorem(8px);
                        }

                        &.sel-active {
                            left: 15% !important;
                            z-index: 999;

                            .role {
                                width: pxTorem(800px);
                                height: pxTorem(800px);
                            }
                        }
                        &.no-sel-active {
                            .role {
                                filter: brightness(0.4);
                            }
                        }

                        &.hover-active {
                            transform: scale(1.1);
                        }
                        &.hover-left {
                            transform: translateX(pxTorem(-20px));
                        }
                        &.hover-right {
                            transform: translateX(pxTorem(20px));
                        }

                        .role {
                            position: absolute;
                            width: pxTorem(600px);
                            height: pxTorem(600px);
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            transition: all 0.3s ease-in-out;
                            pointer-events: none;
                        }
                    }
                }
            }
            .mover-container {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                position: absolute;
                top: 0;
                left: 0;

                .mover-box {
                    width: pxTorem(270px);
                    height: 60%;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    box-sizing: border-box;
                    cursor: pointer;
                }
            }
        }
}

/* camp */
.slideTop-enter-active, .slideTop-leave-active {
    transition: all 0.5s ease-in-out;
}
.slideTop-enter,
.slideTop-leave-to {
    transform: translateY(-100%) translateZ(0);
    opacity: 0;
}
.slideBottom-enter-active, .slideBottom-leave-active{
    transition: all .5s ease-in-out;
}
.slideBottom-enter,
.slideBottom-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
/* camp-logo */
.camplogo-enter-active, .camplogo-leave-active{
    transition: all .3s ease-in-out;
} 
.camplogo-enter,
.camplogo-leave-to {
    opacity: 0;
}
/* role-class */
.roleClass-enter-active,
.roleClass-leave-active {
    transition: all 0.2s ease-in-out !important;
    transform-origin: left center !important;
}
.roleClass-enter-active {
    transition-delay: 0.5s !important;
}
.roleClass-enter,
.roleClass-leave-to {
    transform: scaleX(0) !important;
}
/* role-text clip */
.clip-enter-active,.clip-leave-active {
    transition: clip-path ease-in-out .3s;
    transition-delay: 0.7s;
}
.clip-enter, .clip-leave-to {
    clip-path: polygon(0 100%,0 100%,100% 100%,100% 100%);
}
.clip-enter-to, .clip-leave {
    clip-path: polygon(0 100%,0 0,100% 0,100% 100%);
}

/* role-detail */
.roleDetail-enter-active,
.roleDetail-leave-active {
    transition: transform 0.3s ease-in-out !important;
    transform-origin: left center !important;
}
.roleDetail-enter-active {
    transition-delay: 0.3s !important;
}
.roleDetail-enter,
.roleDetail-leave-to {
    transform: translateY(-50%) scaleX(0) !important;
}
</style>
